import React from 'react';

import { Button, Header } from '@rbilabs/universal-components';
import { Platform, StyleSheet } from 'react-native';

import Dialog from 'components/dialog';
import Picture from 'components/picture';
import { Box, BoxProps } from 'components/ui';
import { primitive } from 'styles/constants';

export const StyledHeader = Header.withConfig({
  fontSize: '2xl',
  fontWeight: primitive.$fontWeightHeavy,
  accessibilityLevel: 1,
  variant: 'headerOne',
  textAlign: 'center',
  fontFamily: 'body',
  marginBottom: '$3',
});

export const StyledBody = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.body, style] });

export const StyledDialog = Dialog.withConfig({
  paddingTop: '$4',
  textAlign: 'left',
});

export const StyledPicture = Picture.withConfig({
  maxWidth: '85%',
  alignSelf: 'center',
  marginBottom: '$3',
});

export const StyledTextOnlyButton = Button.withConfig({
  variant: 'ghost',
  paddingX: '$12',
  paddingY: '$3',
  marginTop: '$1',
  _text: {
    textTransform: 'capitalize',
  },
});

export const StyledButton = Button.withConfig({
  _text: {
    textTransform: 'capitalize',
  },
});

export const StyledOutlineButton = Button.withConfig({
  variant: 'outline',
});

const styles = StyleSheet.create({
  body: {
    marginBottom: Platform.OS === 'android' ? 16 : 12,
  },
});
